import React from 'react';
import {Glyphicon} from "../../../Common/GlyphIcon";

export const QueryToolEmptyState = ({onStartQuery}) => (
    <div className="sb-query-tool-empty-state">
        <Glyphicon
            glyph="plus-sign"
            onClick={onStartQuery}
        />
        <div className="empty-table">
            <Glyphicon
                className="glyphicon-plus-sign"
                glyph="plus-sign"
                onClick={onStartQuery}
            />
            <div className="empty-table-title">
                Start A Query
            </div>
        </div>
    </div>
);
